import type { LocationQueryValue, RouteLocationRaw } from 'vue-router';

export const AUTH_REDIRECT_QUERY = 'redirect';

export function getAuthRedirect(value: LocationQueryValue | LocationQueryValue[] | undefined)
{
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//'))
        return;

    return value;
}

export function withAuthRedirect(route: RouteLocationRaw, redirect?: string): RouteLocationRaw
{
    if (!redirect)
        return route;

    if (typeof route === 'string')
    {
        return {
            path: route,
            query: { [AUTH_REDIRECT_QUERY]: redirect }
        };
    }

    return {
        ...route,
        query: {
            ...route.query,
            [AUTH_REDIRECT_QUERY]: redirect
        }
    };
}
